import produce from 'immer';
import {
  ADD_CATEGORY,
  ADD_CATEGORY_SUCCESS,
  ADD_FILE_SUCCESS,
  CATEGORY_PERMISSIONS,
  CHANGE_STATUS,
  DELETE_CATEGORY,
  DELETE_CATEGORY_SUCCESS,
  FETCH_CATEGORIES,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_FOLDER_SUCCESS,
  FETCH_FOLDERS,
  FETCH_FOLDERS_FAILED,
  FETCH_FOLDERS_SUCCESS,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CONTEXT_MENU,
  UPDATE_SEQUENCE,
  UPDATE_SEQUENCE_SUCCESS,
} from 'actions/categoryActions';

export const initialState = {
  list: [],
  fetching: false,
  fetchSuccess: false,
  fetchFailed: false,
  statusText: null,
  addUpdateSuccess: false,
  addedId: null,
  deletedId: null,
  sharedList: [],
  folders: [],
  insideFolder: null,
  selectedPermission: null,
  updateSequenceSuccess: false,
};

/* eslint-disable default-case, no-param-reassign */
const categoryReducer = (state = initialState, action) =>
  // eslint-disable-next-line consistent-return
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CATEGORIES:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        if (!action.update && action.pageFolderId) {
          draft.list = [];
        }
        break;

      case FETCH_CATEGORIES_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        if (action.pageFolderId) {
          draft.list = action.categories;
        } else {
          draft.sharedList = action.categories;
        }
        break;

      case DELETE_CATEGORY:
        draft.deletedId = null;
        draft.deleteSuccess = false;
        draft.addUpdateSuccess = false;
        break;
      case DELETE_CATEGORY_SUCCESS:
        draft.deletedId = action.category;
        draft.deleteSuccess = true;
        draft.addUpdateSuccess = true;
        break;
      case UPDATE_CATEGORY:
        draft.addUpdateSuccess = false;
        break;
      case UPDATE_CATEGORY_SUCCESS:
        draft.addUpdateSuccess = true;
        break;
      case ADD_CATEGORY:
        draft.addedId = null;
        draft.addUpdateSuccess = false;
        break;
      case UPDATE_SEQUENCE:
        draft.updateSequenceSuccess = false;
        break;
      case UPDATE_SEQUENCE_SUCCESS:
        draft.updateSequenceSuccess = true;
        break;

      case ADD_CATEGORY_SUCCESS:
        draft.addedId = action.category;

        draft.addUpdateSuccess = true;
        break;
      case CHANGE_STATUS:
        draft.addUpdateSuccess = false;
        draft.addedId = null;
        break;
      case UPDATE_CONTEXT_MENU:
        draft.contextData = action.data;
        break;
      case FETCH_FOLDERS:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        break;

      case FETCH_FOLDERS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.folders = action.folders;
        draft.total = action.total;
        break;

      case FETCH_FOLDERS_FAILED:
        draft.fetching = false;
        draft.fetchSuccess = false;
        draft.fetchFailed = true;
        draft.statusText = action.statusText;
        break;
      case ADD_FILE_SUCCESS:
        draft.folders.push(action.file);
        break;
      case FETCH_FOLDER_SUCCESS:
        draft.insideFolder = action.folder;
        break;
      case CATEGORY_PERMISSIONS:
        draft.selectedPermission = action.permission;
        break;
    }
  });

export default categoryReducer;
